import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AdminProfile from "./AdminProfile";

import CustomerProfile from "./CustomerProfile";
import AgentProfile from "./Agent";

import { useCommonContext } from "../../../utils/context";

const Profile = ({ show, handleClose }) => {
  const role = localStorage.getItem("role");

  const { fetchUser, user } = useCommonContext();

  // if (loading) {
  //   return <div>Loading...</div>;
  // }

  return (
    <div>
      {role === "admin" && (
        <AdminProfile
          user={user}
          show={show}
          fetchUser={fetchUser}
          handleClose={handleClose}
        />
      )}
      {["agent", "superuser", "technician", "sales"].includes(role) && (
        <AgentProfile
          user={user}
          show={show}
          fetchUser={fetchUser}
          handleClose={handleClose}
        />
      )}

      {role === "customer" && (
        <CustomerProfile
          user={user}
          show={show}
          fetchUser={fetchUser}
          handleClose={handleClose}
        />
      )}
      {role === "subcustomer" && (
        <CustomerProfile
          user={user}
          show={show}
          fetchUser={fetchUser}
          handleClose={handleClose}
        />
      )}
    </div>
  );
};

export default Profile;
